import { NumericFormat } from 'react-number-format';
import styles from './Format.module.css';
import FormatProps, { DEFAULT_VALUE } from './FormatProps';

export default function DollarFormat({
  value,
  outsideBenchmark = false,
  showDefaultValue = false,
  className = ''
}: FormatProps) {
  return (
    <NumericFormat
      displayType="text"
      thousandSeparator=","
      decimalScale={0}
      value={value}
      renderText={(value) => (
        <p
          className={`${styles.container} ${outsideBenchmark ? styles.outside_benchmark : ''} ${className}`.trim()}>
          {value ? value : showDefaultValue && DEFAULT_VALUE}
        </p>
      )}
    />
  );
}
